import {createRouter, createWebHistory} from 'vue-router'
import castParams from './router/castParams'
import {useUserStore} from '@/stores/userStore'

const legalPages = ['/privacy-policy', '/terms-of-service', '/disclaimer']

const routes = [
  {
    path: '',
    component: () => import ('./Site.vue')
  },
  {
    path: '/'
  },
  {
    path: '/invite',
    component: () => import ('../components/pub/invite/AcceptInvite.vue')
  },
  {
    path: '/forgot-password',
    component: () => import ('../components/freshability/auth/forgot-password/ForgotPassword.vue')
  },
  {
    path: '/reset-password/:token',
    component: () => import ('../components/freshability/auth/reset-password/ResetPassword.vue'),
    props: true
  },
  {
    path: '/privacy-policy',
    component: () => import ('../components/pub/legal/PrivacyPolicy.vue')
  },
  {
    path: '/terms-of-service',
    component: () => import ('../components/pub/legal/TermsOfService.vue')
  },
  {
    path: '/disclaimer',
    component: () => import ('../components/pub/legal/Disclaimer.vue')
  }
]


// Determine base path based on current location
const getBasePath = () => {
  const path = window.location.pathname
  if (path.startsWith('/forgot-password') || path.startsWith('/reset-password')) {
    return ''
  }
  if (legalPages.some(p => path.startsWith(p))) {
    return ''
  }
  return '/pub'
}

const router = createRouter({
  // 4. Provide the history implementation to use. We are using the hash history for simplicity here.
  history: createWebHistory(getBasePath()),
  routes, // short for `routes: routes`
})

router.afterEach((to, from) => {
  window.scrollTo(0,0)
})

router.beforeEach((to, from, next) => {
  const userStore = useUserStore()

  if (userStore.isAuthenticated && !legalPages.includes(to.path)) {
    window.location = '/'
    return
  }

  return next()
})

export default router
